<template>
    <div>
        <div class="text-center">
            <qrcard-component :qrcode="qrcode" :name="name" :shop="shop" ref="card"></qrcard-component>
        </div>
        <div class="text-right mt-2">
            <button
                class="mx-auto bg-teal-400 hover:bg-teal-500 focus:shadow-outline focus:outline-none text-white text-sm py-2 px-4 rounded"
                @click="download">ダウンロード
            </button>
            <button
                class="mx-auto bg-orange-400 hover:bg-orange-500 focus:shadow-outline focus:outline-none text-white text-sm py-2 px-4 rounded"
                @click="print">印刷
            </button>
            <a class="inline-block mx-auto bg-gray-500 hover:bg-gray-600 focus:shadow-outline focus:outline-none text-white text-sm py-2 px-4 rounded"
               v-if="editpath" :href="editpath">編集</a>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'qrcode',
            'name',
            'shop',
            'editpath',
        ],

        methods: {
            download() {
                this.$refs.card.download();
            },

            print() {
                this.$refs.card.print();
            },
        },
    }
</script>
